import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { HttpClient } from "@angular/common/http";
import { BaseService } from './BaseService';
import { ISPTProcess } from "../Models/ISPTProcess";
import { ISPTCaseFile } from "../Models/ISPTCaseFile";
import { ISPTReferral } from "../Models/ISPTReferral";
import { ISPTPreReferralStrategyForm } from "../Models/ISPTPreReferralStrategyForm";
import { ISPTMeetingLog } from "../Models/ISPTMeetingLog";
import { ISPTResponseToIntervention } from "../Models/ISPTResponseToIntervention";
import { ISPTDocument } from "../Models/ISPTDocument";
import { ISPTBlankDocument } from "../Models/ISPTBlankDocument";

@Injectable()
export class SPTProcessService extends BaseService {
  _baseUrl: string = "";

  constructor(protected _http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    super(_http);
    this._baseUrl = baseUrl;
  }

  getAllSPTProcess(localStudentId: string) {
    return this._http.get(this._baseUrl + "api/SPTProcess/GetSPTProcessList/" + localStudentId)
      .map((response: ISPTProcess[]) => response as ISPTProcess[])
      .catch(this.errorHandler);
  }

  getSPTCaseFile(id: number) {
    return this._http.get(this._baseUrl + "api/SPTProcess/GetSPTCaseFile/" + id)
      .map((response: ISPTCaseFile) => response as ISPTCaseFile)
      .catch(this.errorHandler);
  }

  getSPTReferral(id: number) {
    return this._http.get(this._baseUrl + "api/SPTProcess/GetSPTReferral/" + id)
      .map((response: ISPTReferral) => response as ISPTReferral)
      .catch(this.errorHandler);
  }

  getSPTReferralForCase(id: number) {
    return this._http.get(this._baseUrl + "api/SPTProcess/GetSPTReferralForCase/" + id)
      .map((response: ISPTReferral[]) => response as ISPTReferral[])
      .catch(this.errorHandler);
  }

  getSPTPreReferralStrategy(id: number) {
    return this._http.get(this._baseUrl + "api/SPTProcess/GetSPTPreReferralStrategyForm/" + id)
      .map((response: ISPTPreReferralStrategyForm) => response as ISPTPreReferralStrategyForm)
      .catch(this.errorHandler);
  }

  getSPTPreReferralStrategyForCase(id: number) {
    return this._http.get(this._baseUrl + "api/SPTProcess/GetSPTPreReferralStrategyFormForCase/" + id)
      .map((response: ISPTPreReferralStrategyForm[]) => response as ISPTPreReferralStrategyForm[])
      .catch(this.errorHandler);
  }

  getSPTMeetingLogForCase(id: number) {
    return this._http.get(this._baseUrl + "api/SPTProcess/GetSPTMeetingLogForCase/" + id)
      .map((response: ISPTMeetingLog[]) => response as ISPTMeetingLog[])
      .catch(this.errorHandler);
  }

  getSPTResponseToInterventionForCase(id: number) {
    return this._http.get(this._baseUrl + "api/SPTProcess/GetSPTResponseToInterventionListForCase/" + id)
      .map((response: ISPTResponseToIntervention[]) => response as ISPTResponseToIntervention[])
      .catch(this.errorHandler);
  }

  getAllDocuments(id: number) {
    return this._http.get(this._baseUrl + "api/SPTProcess/GetSPTDocumentListForCase/" + id)
      .map((response: ISPTDocument[]) => response as ISPTDocument[])
      .catch(this.errorHandler);
  }

  getAllBlankDocuments() {
    return this._http.get(this._baseUrl + "api/SPTProcess/GetSPTBlankDocumentList")
      .map((response: ISPTBlankDocument[]) => response as ISPTBlankDocument[])
      .catch(this.errorHandler);
  }

  insertUpdateSPTReferral(sptSPTReferralDetails: ISPTReferral) {
    return this._http.post(this._baseUrl + 'api/SPTProcess/InsertUpdateSPTReferral', sptSPTReferralDetails)
      .map((response: ISPTReferral) => response as ISPTReferral)
      .catch(this.errorHandler);
  }

  insertUpdateSPTPreReferralStrategy(sptPreReferralStrategyDetails: ISPTPreReferralStrategyForm) {
    return this._http.post(this._baseUrl + 'api/SPTProcess/InsertUpdateSPTPreReferralStrategyForm', sptPreReferralStrategyDetails)
      .map((response: ISPTPreReferralStrategyForm) => response as ISPTPreReferralStrategyForm)
      .catch(this.errorHandler);
  }

  insertUpdateSPTMeetingLog(sptMeetingLogDetails: ISPTMeetingLog) {
    return this._http.post(this._baseUrl + 'api/SPTProcess/InsertUpdateSPTMeetingLog', sptMeetingLogDetails)
      .map((response: ISPTMeetingLog) => response as ISPTMeetingLog)
      .catch(this.errorHandler);
  }

  insertUpdateSPTResponseToIntervention(sptResponseToInterventionDetails: ISPTResponseToIntervention) {
    return this._http.post(this._baseUrl + 'api/SPTProcess/InsertUpdateSPTResponseToIntervention', sptResponseToInterventionDetails)
      .map((response: ISPTResponseToIntervention) => response as ISPTResponseToIntervention)
      .catch(this.errorHandler);
  }

  insertSPTDocument(sptDocumentDetails: ISPTDocument) {
    return this._http.post(this._baseUrl + 'api/SPTProcess/InsertSPTDocument', sptDocumentDetails)
      .map((response: ISPTDocument) => response as ISPTDocument)
      .catch(this.errorHandler);
  }

  insertUpdateSPTBlankDocument(sptBlankDocumentDetails: ISPTBlankDocument) {
    return this._http.post(this._baseUrl + 'api/SPTProcess/InsertUpdateSPTBlankDocument', sptBlankDocumentDetails)
      .map((response: ISPTBlankDocument) => response as ISPTBlankDocument)
      .catch(this.errorHandler);
  }

  insertUpdateSPTCaseFile(sptSPTReferralDetails: ISPTCaseFile) {
    return this._http.post(this._baseUrl + 'api/SPTProcess/InsertUpdateSPTCaseFile', sptSPTReferralDetails)
      .map((response: ISPTCaseFile) => response as ISPTCaseFile)
      .catch(this.errorHandler);
  }

  deleteSPTProcess(id) {
    return this._http.delete(this._baseUrl + "api/SPTProcess" + id)
      .map((response: ISPTProcess) => response as ISPTProcess)
      .catch(this.errorHandler)
  }

  errorHandler(error: Response) {
    console.log(error);
    return Observable.throw(error);
  }
}



